<template>
  <Modal
    :visible="visible"
    :footer="null"
    :destroyOnClose="true"
    wrap-class-name="empty-modal"
    @cancel="visible = false"
    width="1000px"
  >
    <div>
      <iframe
        :src="`${apiUrl}/custom-email-campaign-sent/view/campaign?program_id=${campaignRecordId}&token=${token}`"
        frameborder="0"
        width="100%"
        style="min-height: 75vh"
        title="preview email"
      ></iframe>
    </div>
  </Modal>
  <section class="members-data">
    <div class="mt-2 md:mt-5 lg:mt-1">
      <Table
        :data-source="tableFormatedData"
        :columns="columns"
        :loading="customEmailsQuery?.isFetching"
        :pagination="false"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'name'">
            <span v-if="record?.name" class="whitespace-nowrap w-full flex justify-center">{{
              record?.name
            }}</span>
            <span v-else class="w-full flex justify-center text-yellow-600">N/A</span>
          </template>
          <template v-if="column.key === 'no_users'">
            <span v-if="record?.no_users" class="whitespace-nowrap w-full flex justify-center">{{
              record?.no_users
            }}</span>
            <span v-else class="w-full flex justify-center text-yellow-600">N/A</span>
          </template>
          <template v-if="column.key === 'sent'">
            <span class="whitespace-nowrap w-full flex justify-center">{{
              record?.sent ? 'Yes' : 'No'
            }}</span>
          </template>
          <template v-if="column.key === 'sample_sent'">
            <span class="whitespace-nowrap w-full flex justify-center">
              <Button
                type="primary"
                size="small"
                title="View Campaign"
                class="btn-success rounded flex justify-center shadow m-auto items-center"
                @click="() => viewMail(record.id)"
                v-if="record?.sent"
              >
                <PhFile weight="duotone" :size="16" /> View
              </Button>
              <span v-else class="w-full flex justify-center text-yellow-600">N/A</span>
            </span>
          </template>
        </template>
      </Table>

      <div
        v-if="customEmailsQuery && customEmailsQuery.data"
        class="mt-6 flex items-center justify-center"
      >
        <Pagination
          :current="customEmailsQuery?.data?.current_page"
          :total="customEmailsQuery?.data?.total"
          show-less-items
          @change="handlePaginationChange"
          :page-size="10"
        />
      </div>
    </div>
  </section>
  <OldCampaignsQuery :page="page" :key="`${page}`" />
</template>
<script>
/* eslint-disable */
import campaignsApi from '@/services/apis/admin/campaigns.api';
import { getToken } from '@/services/jwt.service';
import OldCampaignsQuery from '@/services/queries/admin/campaigns/OldCampaignsQuery.vue';
import { Button, message, Modal, Pagination, Popconfirm, Table } from 'ant-design-vue';
import { PhFile, PhTrash } from 'phosphor-vue';

export default {
  components: {
    Table,
    OldCampaignsQuery,
    Pagination,
    Button,
    PhFile,
    PhTrash,
    Popconfirm,
    Modal,
  },
  data() {
    return {
      columns: [
        { title: 'Batch scheduled at', dataIndex: 'name', key: 'name' },
        { title: '# of emails to be sent', dataIndex: 'no_users', key: 'no_users' },
        { title: 'Sent', dataIndex: 'sent', key: 'sent' },
        { title: 'Sample sent', dataIndex: 'sample_sent', key: 'sample_sent' },
      ],
      tableData: [],
      page: 1,
      visible: false,
      campaignRecordId: null,
      token: null,
    };
  },
  computed: {
    tableFormatedData() {
      const data = this?.customEmailsQuery?.map((d, ix) => ({
        no_users: d?.emails?.length || 0,
        name: d?.formatted_Date ?? '',
        sent: d?.sent ?? false,
        key: ix + 1,
        id: d?._id,
      }));
      return data;
    },
    customEmailsQuery() {
      return this.$store.state.campaigns.campaignViewData?.records;
    },
    apiUrl() {
      return process.env.VUE_APP_API || 'https://dev.api.commutrics.com/api';
    },
  },
  methods: {
    handlePaginationChange(page) {
      // , filters, sorter, data
      this.page = page;
    },
    goTo(url) {
      this.$router.push(url);
    },
    async deleteCampaign(record) {
      if (!record || !record.id) return;

      await campaignsApi.deleteCampaign({ id: record.id });
      this.customEmailsQuery?.refetch();
      message.success('Campaign deleted successfully');
    },
    viewMail(id) {
      if (!id) return;
      this.campaignRecordId = id;
      this.visible = true;
    },
  },
  created() {
    this.token = getToken();
  },
};
</script>
